import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/Store';
import { BlogPost } from '../../models/blog/BlogPost';
import { useLocale } from '../../context/LocaleContext';
import TerraformIcon from './TerraformIcon';
import './BlogWidget.css';

const POSTS_TO_SHOW = 4;

function formatDate(iso: string, locale: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString(locale === 'da' ? 'da-DK' : 'en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

const BlogWidget: React.FC = () => {
  const { t, locale, pathFor } = useLocale();
  const posts = useSelector((state: RootState) => state.blog.data);
  const sorted = [...(posts || [])].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );
  const recent = sorted.slice(0, POSTS_TO_SHOW);

  if (recent.length === 0) return null;

  return (
    <div className="blog-section">
      <div className="blog-section-header">
        <h2 className="blog-section-title">{t('home.blog.title')}</h2>
        <Link to={pathFor('blog')} className="blog-view-all">
          {t('home.blog.viewAll')}
        </Link>
      </div>
      <div className="blog-widget-grid" role="region" aria-label="Blog posts">
        {recent.map((post: BlogPost) => {
          const cardContent = (
            <>
              <div className="blog-widget-emoji" aria-hidden>
                {post.icon === 'terraform' ? (
                  <TerraformIcon size={28} />
                ) : (
                  post.emoji || '📄'
                )}
              </div>
              <div className="blog-widget-body">
                <span className="blog-widget-date">{formatDate(post.date, locale)}</span>
                <h3 className="blog-widget-card-title">{post.title}</h3>
                <p className="blog-widget-excerpt">{post.excerpt}</p>
              </div>
            </>
          );
          return post.externalUrl ? (
            <a
              key={post.id}
              href={post.externalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="blog-widget-card"
            >
              {cardContent}
            </a>
          ) : (
            <Link
              key={post.id}
              to={pathFor(`blog/${post.id}`)}
              className="blog-widget-card"
            >
              {cardContent}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BlogWidget;
